import Link from "next/link";
import { GuideType } from "types";
import { Reveal } from "../reveal";
import { Button } from "../ui/button";

interface GuideCardProps {
  guide: GuideType;
}

export function GuideCard({ guide }: GuideCardProps) {
  const { title, summary, slug } = guide;
  return (
    <Reveal
      className="flex flex-col xs:flex-row bg-white w-full"
      initialY="10%"
    >
      <div className="p-4 sm:p-6 flex flex-col gap-4 justify-between w-full">
        <div className="flex flex-col gap-3">
          <h4 className="text-xl sm:text-2xl font-semibold leading-tight tracking-tight text-[#181818] sm:max-w-[260px] line-clamp-3">
            {title}
          </h4>
          <p className="text-sm sm:text-base leading-relaxed text-neutral-600 line-clamp-3">
            {summary}
          </p>
        </div>
        <Button asChild variant="outline" radius="full">
          <Link href={`/guides/${slug}`}>Read More</Link>
        </Button>
      </div>
    </Reveal>
  );
}
